import { InputAdornment } from '@mui/material';
import { ClientInput } from 'admin/inputs/ClientInput';
import { DateInput } from 'admin/inputs/DateInput';
import { ExpectedAmountInput } from 'admin/inputs/ExpectedAmountInput';
import { InstitutionInput } from 'admin/inputs/InstitutionInput';
import { ProductStatusInput } from 'admin/products/inputs/ProductStatusInput';
import { RichTextInput } from 'ra-input-rich-text';
import {
  ArrayInput,
  Create,
  FormTab,
  getRecordFromLocation,
  NumberInput,
  SimpleFormIterator,
  TabbedForm,
  TextInput,
} from 'react-admin';
import { useLocation } from 'react-router-dom';

// TODO: generalize components

export const MortgageProductCreate: React.FC = () => {
  const location = useLocation();
  const record = getRecordFromLocation(location);
  return (
    <Create>
      <TabbedForm>
        <FormTab label="Základné info">
          <ClientInput disabled={!!record?.clientId} label="Klient" source="clientId" />
          <InstitutionInput source="institutionId" />
          <TextInput label="Vlastná inštitúcia" source="institutionName" sx={{ maxWidth: '40em', width: '100%' }} />
          <TextInput label="Názov produktu" source="name" sx={{ maxWidth: '40em', width: '100%' }} />
        </FormTab>

        <FormTab label="Zmluva">
          <TextInput label="Číslo zmluvy" source="contractNumber" sx={{ maxWidth: '40em', width: '100%' }} />
          <DateInput label="Dátum podpisu zmluvy" source="contractSignDate" />
          <DateInput label="Platnosť zmluvy do" source="contractEndDate" />
        </FormTab>

        <FormTab label="Platby">
          <ExpectedAmountInput label="Výška mesačnej splátky" source="paymentPeriod.expectedAmount.amount" />
          <DateInput label="Nasledujúca platba" source="paymentPeriod.expectedDate" />
        </FormTab>

        <FormTab label="Informácie o hypotéke">
          <DateInput defaultValue={new Date()} label="platné k" source="financialDetailsUpdatedAt" />
          <NumberInput label="Pôvodná výška hypotéky" source="amount.amount" />
          <NumberInput label="Výška nesplatenej časti hypotéky" source="balance.amount" />
          <NumberInput
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            format={(v) => v * 100}
            label="Aktuálna úroková sadzba"
            parse={(v) => parseFloat(v) / 100}
            source="interestRate"
          />
          <NumberInput
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            format={(v) => v * 100}
            label="Ročná percentuálna miera nákladov"
            parse={(v) => parseFloat(v) / 100}
            source="annualPercentageRate"
          />
          <NumberInput label="Dĺžka fixácie v rokoch" source="fixationLength" />
          <DateInput label="Výročie fixácie úrokovej sadzby" source="fixationEndDate" />
        </FormTab>

        <FormTab label="Založené nehnuteľnosti">
          <ArrayInput label="Založené nehnuteľnosti" source="collaterals">
            <SimpleFormIterator inline>
              <TextInput helperText={false} label="Adresa" source="address" sx={{ maxWidth: '40em', width: '100%' }} />
            </SimpleFormIterator>
          </ArrayInput>
        </FormTab>

        <FormTab label="Účastníci úverového vzťahu">
          <ArrayInput label="Účastníci úverového vzťahu" source="participants">
            <SimpleFormIterator inline>
              <TextInput helperText={false} label="Meno" source="name" sx={{ maxWidth: '40em', width: '100%' }} />
            </SimpleFormIterator>
          </ArrayInput>
        </FormTab>

        <FormTab label="Status">
          <ProductStatusInput label="Status" source="status" />
        </FormTab>

        <FormTab label="Poznámka">
          <RichTextInput
            label="Poznámka"
            source="note"
            sx={{ '& .tiptap': { minHeight: '20em' }, maxWidth: '40em', width: '100%' }}
          />
        </FormTab>
      </TabbedForm>
    </Create>
  );
};
